import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { SubSubGroupDto, SubGroupDto, CategoryDto, SubSubGroupTypeDto, SubSubGroupTypeCategoryDto} from '@cradua/data';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';


@Component({
  selector: 'cradua-subsubgroup',
  templateUrl: './subsubgroup.component.html',
  styleUrls: ['./subsubgroup.component.scss']
})
export class SubSubGroupComponent implements OnChanges {

  @Input() subsubgroups: SubSubGroupDto[];
  @Input() subgroups: SubGroupDto[];
  @Input() categorys: CategoryDto[]
  @Input() subsubgrouptypes: SubSubGroupTypeDto[]
  @Input() subsubgrouptypecategorys: SubSubGroupTypeCategoryDto[]
  subsubgroupForm: FormGroup;
  subsubgroupFormArray: FormGroup;
  control = new FormControl();
  @Input() routeAnimationsElements: any;
  @Output() changeEmit = new EventEmitter<SubSubGroupDto>();
  @Output() deleteEvent = new EventEmitter<any>();

  filteredDelete: Array<any> = [];
  filteredSubSubGroup: Array<any> = [];
  status: boolean;
  selectedSubSubGroupId: any;
  selectedIndex = null;

  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createSubSubGroupForm();
  }

  createSubSubGroupForm() {
    this.subsubgroupFormArray = this.fb.group({ SubSubGroups: this.fb.array([]) });
    this.subsubgroupForm = this.fb.group({
        SubSubGroupName: ['', Validators.required],       
        SubSubGroupCode: [''],
        SubGroupId: this.selectedSubSubGroupId,
        CategoryId: [''],
        SubSubGroupTypeId: ['', Validators.required],
        SubSubGroupTypeCategoryId: ['', Validators.required],
        id: null
    });
  }


  // method to display companies
  setSubSubGroup() {
    const control = this.subsubgroupFormArray.controls.SubSubGroups as FormArray;
    this.filteredSubSubGroup.forEach((e) => {
      control.push(
        this.fb.group({
            SubSubGroupName: e.SubSubGroupName,
            SubSubGroupCode: e.SubSubGroupCode,
            SubGroupId: e.SubGroupId,
            CategoryId: e.CategoryId,
            SubSubGroupTypeId: e.SubSubGroupTypeId,
            SubSubGroupTypeCategoryId: e.SubSubGroupTypeCategoryId,
          id: e.id,
        })
      );
    });
  }

   // method to add Company
   addSubSubGroup(subsubgroup: SubSubGroupDto) {
    console.log('subsubgroup');
    const control = this.subsubgroupFormArray.controls.SubSubGroups as FormArray;
    control.insert(
      0,
      this.fb.group({
        SubSubGroupName: subsubgroup.SubSubGroupName,  
        SubSubGroupCode: subsubgroup.SubSubGroupCode,
        SubGroupId: this.selectedSubSubGroupId,
        CategoryId: subsubgroup.CategoryId,
        SubSubGroupTypeId: subsubgroup.SubSubGroupTypeId,
        SubSubGroupTypeCategoryId: subsubgroup.SubSubGroupTypeCategoryId,

      })
    );
  }


  // method to reset form array after selection
  clearFormArray = (formArray: FormArray) => {
    const control = this.subsubgroupFormArray.controls.SubSubGroups as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  // method to filter country
  selectSubGroup(event: string) {
    this.filteredSubSubGroup = this.subsubgroups.filter((s) => s.SubGroupId === event);
    this.selectedSubSubGroupId = event;
    const control = this.subsubgroupFormArray.controls.SubSubGroups as FormArray;

    if (this.filteredSubSubGroup.length > 0) {
      this.status = true;
      this.clearFormArray(control);
      this.setSubSubGroup();
    } else {
      this.status = true;
      this.clearFormArray(control);
    }
  }

  print(event: any) {
    window.print();
  }
  // method to delete company from arrary list
  deleteSubSubGroup(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.subsubgroupFormArray.controls.SubSubGroups as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.subsubgroups.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.subsubgroups[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }


  addNew(formValue: SubSubGroupDto) {
    if(this.subsubgroupForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.subsubgroupFormArray.get('SubSubGroups')['controls'][this.selectedIndex].patchValue(formValue);
    } else {
      this.addSubSubGroup(formValue);
    }
    this.selectedIndex = null;
    this.subsubgroupForm.reset()
  }

  onEdit(index, value: SubSubGroupDto) {
    this.selectedIndex = index;
    this.subsubgroupForm.patchValue(value);
  }

  onClearForm() {
    this.selectedIndex = null;
    this.subsubgroupForm.reset();
  }


  getCategoryName(id: string) {
    const found = this.categorys.find(acc => acc.id === id);
    // console.log('log ', id)
    return found ? found.CategoryName : '';
  }
  getSubSubGroupTypeName(id: string) {
    const found = this.subsubgrouptypes.find(acc => acc.id === id);
    // console.log('log ', id)
    return found ? found.SubSubGroupTypeName : '';
  }
  getSubSubGroupTypeCategoryName(id: string) {
    const found = this.subsubgrouptypecategorys.find(acc => acc.id === id);
    // console.log('log ', id)
    return found ? found.SubSubGroupTypeCategoryName : '';
  }

  onSubmit(formValue: any) {
    formValue.type = 'subsubgroup';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length > 0) {
      this.filteredDelete.unshift('subsubgroup');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }

}
